(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elsvin-birthday-club"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  const field = event.target;
  if (!field.matches('[data-birthday-month], [data-birthday-day]')) return;
  const group = field.closest('.elsvin-birthday__child');
  const month = group.querySelector('[data-birthday-month]');
  const day = group.querySelector('[data-birthday-day]');
  const monthNumber = Number(month.selectedOptions[0].dataset.monthNumber);
  const maximum = monthNumber ? new Date(2000, monthNumber, 0).getDate() : 31;
  for (const option of day.options) option.disabled = Number(option.value) > maximum;
  day.setCustomValidity(Number(day.value) > maximum ? day.dataset.invalidDate : '');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elsvin-gift-basket-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elsvin-gift-basket')) {
    customElements.define('elsvin-gift-basket', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('[data-gift-basket]');
        this.items = new Map();
        this.currency = this.root.dataset.currency || 'USD';
        this.root.querySelector('[data-selected-items]').addEventListener('click', (event) => {
          const removeButton = event.target.closest('[data-remove-selected]');
          if (!removeButton) return;
          const productId = removeButton.dataset.removeSelected;
          this.items.delete(productId);
          this.syncProductCards(productId);
          this.render();
        });
        this.bindCollectionPicker();
        this.bindCards();
        this.root.querySelectorAll('[data-extra]').forEach((extra) => {
          extra.querySelector('[data-extra-check]').addEventListener('change', () => this.render());
          const select = extra.querySelector('[data-extra-variant]');
          if (select.tagName === 'SELECT') select.addEventListener('change', () => this.render());
        });
        this.root.querySelector('[data-add-basket]').addEventListener('click', () => this.addBasket());
        this.render();
      }

      bindCollectionPicker() {
        const select = this.root.querySelector('[data-collection-select]');
        if (!select) return;
        select.addEventListener('change', () => {
          this.root.querySelectorAll('[data-collection-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.collectionHandle !== select.value;
          });
          this.items.forEach((item, productId) => this.syncProductCards(productId));
        });
      }

      bindCards() {
        this.root.querySelectorAll('[data-gift-card]').forEach((card) => {
          const variant = card.querySelector('[data-variant-select]');
          if (variant.tagName === 'SELECT') variant.addEventListener('change', () => this.variantChanged(card));
          card.querySelector('[data-add-product]').addEventListener('click', () => {
            const selected = variant.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
            const id = selected.value;
            if (!id || (selected.tagName === 'OPTION' && selected.disabled)) return;
            const key = card.dataset.productId;
            const existing = this.items.get(key);
            if (existing) {
              existing.variantId = id;
              existing.card = card;
              existing.maxQuantity = this.stockLimit(selected);
              if (Number.isFinite(existing.maxQuantity) && existing.quantity > existing.maxQuantity) existing.quantity = existing.maxQuantity;
              if (existing.quantity < 1) this.items.delete(key);
            } else {
              this.items.set(key, { card, variantId: id, quantity: 1, maxQuantity: this.stockLimit(selected) });
            }
            this.syncProductCards(key);
            this.render();
          });
          card.querySelector('[data-quantity-minus]').addEventListener('click', () => this.changeQuantity(card, -1));
          card.querySelector('[data-quantity-plus]').addEventListener('click', () => this.changeQuantity(card, 1));
          card.querySelector('[data-remove-product]').addEventListener('click', () => {
            this.items.delete(card.dataset.productId);
            this.syncProductCards(card.dataset.productId);
            this.render();
          });
        });
      }

      variantChanged(card) {
        const control = card.querySelector('[data-variant-select]');
        const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        const price = Number(option.dataset.price || 0);
        card.querySelector('[data-card-price]').textContent = this.formatMoney(price);
        const image = card.querySelector('.elsvin-gift-basket__image');
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
        }
        const item = this.items.get(card.dataset.productId);
        if (item) {
          item.variantId = option.value;
          item.maxQuantity = this.stockLimit(option);
          if (Number.isFinite(item.maxQuantity) && item.quantity > item.maxQuantity) item.quantity = item.maxQuantity;
          if (item.quantity < 1) this.items.delete(card.dataset.productId);
            this.syncProductCards(card.dataset.productId);
        }
        this.render();
      }

      stockLimit(option) {
        return option.dataset.stock !== '' && option.dataset.stock !== undefined ? Number(option.dataset.stock) : Infinity;
      }

      changeQuantity(card, delta) {
        const item = this.items.get(card.dataset.productId);
        if (!item) return;
        if (delta > 0 && Number.isFinite(item.maxQuantity) && item.quantity >= item.maxQuantity) {
          this.root.querySelector('[data-status]').textContent = `Only ${item.maxQuantity} of this option are available in Shopify stock.`;
          return;
        }
        item.quantity += delta;
        if (item.quantity < 1) this.items.delete(card.dataset.productId);
        this.syncProductCards(card.dataset.productId);
        this.render();
      }

      syncProductCards(productId) {
        this.root.querySelectorAll('[data-gift-card]').forEach((card) => {
          if (card.dataset.productId === String(productId)) this.syncCard(card);
        });
      }

      syncCard(card) {
        const item = this.items.get(card.dataset.productId);
        card.querySelector('[data-add-product]').hidden = Boolean(item);
        const quantity = card.querySelector('[data-card-quantity]');
        quantity.hidden = !item;
        if (item) {
          const control = card.querySelector('[data-variant-select]');
          control.value = item.variantId;
          const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
          card.querySelector('[data-card-price]').textContent = this.formatMoney(Number(option.dataset.price || 0));
          const image = card.querySelector('.elsvin-gift-basket__image');
          if (image && option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
          quantity.querySelector('[data-quantity-value]').textContent = item.quantity;
        }
      }

      extraItems() {
        return [...this.root.querySelectorAll('[data-extra]')].filter((extra) => extra.querySelector('[data-extra-check]').checked).map((extra) => {
          const control = extra.querySelector('[data-extra-variant]');
          const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
          return { id: option.value, quantity: 1, price: Number(option.dataset.price || 0), label: extra.querySelector('.elsvin-gift-basket__extra-info > span').textContent.trim() };
        }).filter((item) => item.id);
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.currency }).format(cents / 100);
      }

      render() {
        const list = this.root.querySelector('[data-selected-items]');
        const selected = [...this.items.values()].map((item) => {
          const control = item.card.querySelector('[data-variant-select]');
          const option = control.tagName === 'SELECT' ? [...control.options].find((candidate) => candidate.value === item.variantId) : control;
          return { productId: item.card.dataset.productId, title: item.card.querySelector('h3').textContent, variant: option?.textContent.split(' — ')[0] || '', quantity: item.quantity, price: Number(option?.dataset.price || 0) };
        });
        const extras = this.extraItems();
        const subtotal = selected.reduce((sum, item) => sum + item.price * item.quantity, 0) + extras.reduce((sum, item) => sum + item.price, 0);
        if (selected.length || extras.length) {
          list.innerHTML = [...selected.map((item) => `<div class="elsvin-gift-basket__selected-line"><span>${this.escape(`${item.quantity} × ${item.title}${item.variant ? ` — ${item.variant}` : ''}`)}</span><strong>${this.formatMoney(item.price * item.quantity)}</strong><button type="button" data-remove-selected="${item.productId}" aria-label="Remove ${this.escape(item.title)} from your gift">Remove</button></div>`), ...extras.map((item) => `<div class="elsvin-gift-basket__selected-line"><span>${this.escape(item.label)}</span><strong>${this.formatMoney(item.price)}</strong></div>`)].join('');
        } else {
          list.innerHTML = '<p class="elsvin-gift-basket__empty">Your gift is empty. Add products to get started.</p>';
        }
        this.root.querySelector('[data-total]').textContent = this.formatMoney(subtotal);
        this.root.querySelector('[data-add-basket]').disabled = !selected.length && !extras.length;
      }

      escape(value) {
        const element = document.createElement('span');
        element.textContent = value;
        return element.innerHTML;
      }

      async addBasket() {
        const button = this.root.querySelector('[data-add-basket]');
        const status = this.root.querySelector('[data-status]');
        const properties = {};
        const recipient = this.root.querySelector('[data-recipient]').value.trim();
        const sender = this.root.querySelector('[data-sender]').value.trim();
        const message = this.root.querySelector('[data-message]').value.trim();
        if (recipient) properties['Recipient'] = recipient;
        if (sender) properties['From'] = sender;
        if (message) properties['Gift message'] = message;
        const basketId = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        properties['Gift'] = 'ELSVIN baby gift';
        properties['_gift_basket_id'] = basketId;
        const basketVariantId = Number(this.root.dataset.basketVariantId);
        const items = basketVariantId ? [{ id: basketVariantId, quantity: 1, properties: { ...properties, 'Gift contents': [...this.items.values()].map((item) => item.card.querySelector('h3').textContent.trim()).join(', ') } }] : [];
        [...this.items.values()].forEach((item) => items.push({ id: Number(item.variantId), quantity: item.quantity, properties: { ...properties } }));
        this.extraItems().forEach((item) => items.push({ id: Number(item.id), quantity: 1, properties: { ...properties } }));
        if (!items.length) return;
        button.disabled = true;
        status.textContent = 'Adding your gift to the basket…';
        try {
          const response = await fetch(this.root.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Some items could not be added. Please check availability and try again.');
          status.textContent = 'Your gift was added to the cart.';
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            const sectionResponse = await fetch(`${this.root.dataset.cartUrl}?sections=cart-drawer,cart-icon-bubble`, { headers: { 'Accept': 'application/json' } });
            if (!sectionResponse.ok) throw new Error('Your gift was added. Open the cart to review it.');
            drawer.renderContents({ id: items[0].id, sections: await sectionResponse.json() });
          } else {
            window.location.assign(this.root.dataset.cartUrl);
          }
        } catch (error) {
          status.textContent = error.message || 'We could not add your gift. Please try again.';
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elsvin-gift-basket"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elsvin-gift-basket')) {
    customElements.define('elsvin-gift-basket', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('[data-gift-basket]');
        this.items = new Map();
        this.currency = this.root.dataset.currency || 'USD';
        this.bindCards();
        this.root.querySelectorAll('[data-extra]').forEach((extra) => {
          extra.querySelector('[data-extra-check]').addEventListener('change', () => this.render());
          const select = extra.querySelector('[data-extra-variant]');
          if (select.tagName === 'SELECT') select.addEventListener('change', () => this.render());
        });
        this.root.querySelector('[data-add-basket]').addEventListener('click', () => this.addBasket());
        this.render();
      }

      bindCards() {
        this.root.querySelectorAll('[data-gift-card]').forEach((card) => {
          const variant = card.querySelector('[data-variant-select]');
          if (variant.tagName === 'SELECT') variant.addEventListener('change', () => this.variantChanged(card));
          card.querySelector('[data-add-product]').addEventListener('click', () => {
            const selected = variant.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
            const id = selected.value;
            if (!id || (selected.tagName === 'OPTION' && selected.disabled)) return;
            const key = card.dataset.productId;
            const existing = this.items.get(key);
            if (existing) {
              existing.variantId = id;
            } else {
            this.items.set(key, { card, variantId: id, quantity: 1, maxQuantity: this.stockLimit(selected) });
            }
            this.syncCard(card);
            this.render();
          });
          card.querySelector('[data-quantity-minus]').addEventListener('click', () => this.changeQuantity(card, -1));
          card.querySelector('[data-quantity-plus]').addEventListener('click', () => this.changeQuantity(card, 1));
          card.querySelector('[data-remove-product]').addEventListener('click', () => {
            this.items.delete(card.dataset.productId);
            this.syncCard(card);
            this.render();
          });
        });
      }

      variantChanged(card) {
        const control = card.querySelector('[data-variant-select]');
        const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        const price = Number(option.dataset.price || 0);
        card.querySelector('[data-card-price]').textContent = this.formatMoney(price);
        const image = card.querySelector('.elsvin-gift-basket__image');
        if (image && option.dataset.image) image.src = option.dataset.image;
        const item = this.items.get(card.dataset.productId);
        if (item) {
          item.variantId = option.value;
          item.maxQuantity = this.stockLimit(option);
          if (Number.isFinite(item.maxQuantity) && item.quantity > item.maxQuantity) item.quantity = item.maxQuantity;
          if (item.quantity < 1) this.items.delete(card.dataset.productId);
          this.syncCard(card);
        }
        this.render();
      }

      stockLimit(option) {
        return option.dataset.stock !== '' && option.dataset.stock !== undefined ? Number(option.dataset.stock) : Infinity;
      }

      changeQuantity(card, delta) {
        const item = this.items.get(card.dataset.productId);
        if (!item) return;
        if (delta > 0 && Number.isFinite(item.maxQuantity) && item.quantity >= item.maxQuantity) {
          this.root.querySelector('[data-status]').textContent = `Only ${item.maxQuantity} of this option are available in Shopify stock.`;
          return;
        }
        item.quantity += delta;
        if (item.quantity < 1) this.items.delete(card.dataset.productId);
        this.syncCard(card);
        this.render();
      }

      syncCard(card) {
        const item = this.items.get(card.dataset.productId);
        card.querySelector('[data-add-product]').hidden = Boolean(item);
        const quantity = card.querySelector('[data-card-quantity]');
        quantity.hidden = !item;
        if (item) quantity.querySelector('[data-quantity-value]').textContent = item.quantity;
      }

      extraItems() {
        return [...this.root.querySelectorAll('[data-extra]')].filter((extra) => extra.querySelector('[data-extra-check]').checked).map((extra) => {
          const control = extra.querySelector('[data-extra-variant]');
          const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
          return { id: option.value, quantity: 1, price: Number(option.dataset.price || 0), label: extra.querySelector('.elsvin-gift-basket__extra-info > span').textContent.trim() };
        }).filter((item) => item.id);
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.currency }).format(cents / 100);
      }

      render() {
        const list = this.root.querySelector('[data-selected-items]');
        const selected = [...this.items.values()].map((item) => {
          const control = item.card.querySelector('[data-variant-select]');
          const option = control.tagName === 'SELECT' ? [...control.options].find((candidate) => candidate.value === item.variantId) : control;
          return { title: item.card.querySelector('h3').textContent, variant: option?.textContent.split(' — ')[0] || '', quantity: item.quantity, price: Number(option?.dataset.price || 0) };
        });
        const extras = this.extraItems();
        const subtotal = selected.reduce((sum, item) => sum + item.price * item.quantity, 0) + extras.reduce((sum, item) => sum + item.price, 0);
        if (selected.length || extras.length) {
          list.innerHTML = [...selected.map((item) => `<div class="elsvin-gift-basket__selected-line"><span>${this.escape(`${item.quantity} × ${item.title}${item.variant ? ` — ${item.variant}` : ''}`)}</span><strong>${this.formatMoney(item.price * item.quantity)}</strong></div>`), ...extras.map((item) => `<div class="elsvin-gift-basket__selected-line"><span>${this.escape(item.label)}</span><strong>${this.formatMoney(item.price)}</strong></div>`)].join('');
        } else {
          list.innerHTML = '<p class="elsvin-gift-basket__empty">Your gift is empty. Add products to get started.</p>';
        }
        this.root.querySelector('[data-total]').textContent = this.formatMoney(subtotal);
        this.root.querySelector('[data-add-basket]').disabled = !selected.length && !extras.length;
      }

      escape(value) {
        const element = document.createElement('span');
        element.textContent = value;
        return element.innerHTML;
      }

      async addBasket() {
        const button = this.root.querySelector('[data-add-basket]');
        const status = this.root.querySelector('[data-status]');
        const properties = {};
        const recipient = this.root.querySelector('[data-recipient]').value.trim();
        const sender = this.root.querySelector('[data-sender]').value.trim();
        const message = this.root.querySelector('[data-message]').value.trim();
        if (recipient) properties['Recipient'] = recipient;
        if (sender) properties['From'] = sender;
        if (message) properties['Gift message'] = message;
        const basketId = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        properties['Gift'] = 'ELSVIN baby gift';
        properties['_gift_basket_id'] = basketId;
        const items = [...this.items.values()].map((item) => ({ id: Number(item.variantId), quantity: item.quantity, properties: { ...properties } }));
        this.extraItems().forEach((item) => items.push({ id: Number(item.id), quantity: 1, properties: { ...properties } }));
        if (!items.length) return;
        button.disabled = true;
        status.textContent = 'Adding your gift to the basket…';
        try {
          const response = await fetch(this.root.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Some items could not be added. Please check availability and try again.');
          status.textContent = 'Your gift was added to the cart.';
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            const sectionResponse = await fetch(`${this.root.dataset.cartUrl}?sections=cart-drawer,cart-icon-bubble`, { headers: { 'Accept': 'application/json' } });
            if (!sectionResponse.ok) throw new Error('Your gift was added. Open the cart to review it.');
            drawer.renderContents({ id: items[0].id, sections: await sectionResponse.json() });
          } else {
            window.location.assign(this.root.dataset.cartUrl);
          }
        } catch (error) {
          status.textContent = error.message || 'We could not add your gift. Please try again.';
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            console.log(text);
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
